import { render, staticRenderFns } from "./SkipInventoryReturnDialog.vue?vue&type=template&id=0bf8c487&lang=pug&"
import script from "./SkipInventoryReturnDialog.vue?vue&type=script&lang=js&"
export * from "./SkipInventoryReturnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports